
import { defineComponent } from 'vue';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { app } from '@/firebase/init';
import { storeGitCode } from '@/firebase/databaseDependencyInjectables';
import {
  checkUserInstalledMirosApp,
  GitTokenDetails
} from '@/gitIntegration/gitAuth';

export default defineComponent({
  name: 'GitLogin',
  data(): { installed: boolean } {
    return { installed: false };
  },
  async mounted() {
    console.log(this.$route.query.code);
    if (!this.$route.query.code) return;
    const gitAuth = httpsCallable(getFunctions(app), 'git_auth');
    const res = await gitAuth({ code: this.$route.query.code });
    storeGitCode({
      ...(res.data as any),
      dateObtained: Math.floor(Date.now() / 1000) // seconds
    });
    console.log(res.data as GitTokenDetails);
    this.installed = await checkUserInstalledMirosApp(
      (res.data as GitTokenDetails).access_token
    );
    if (!this.installed) {
      open(
        `https://github.com/apps/miros-app/installations/select_target`,
        '_blank'
      );
    }
  }
});
